import React from 'react';
import '../styles/price.css' 

const Price = () => {
  return (
      <div>
      <span className='price'>&#x20B9;{499}</span> <span className='mrp'>&#x20B9;MRP{1500}</span>
    </div>
  )
}

export default Price